// src/services/authService.js
import api from "@/services/api";

export const authService = {
  signIn(data) {
    return api.post("/login", data).catch(handleError);
  },
};

// Função para tratamento de erro
const handleError = (error) => {
  console.log(error.response.data.message);
  throw error;
};

export default authService;
